import {
  createComponentPreviewMapperModel,
  withCompInfo,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type { IPopupContainerStateRefsValues } from '../PopupContainer.types';
import type { PopupContainerProps as PopupContainerPlatformProps } from '@wix/thunderbolt-components';

export const props = withCompInfo<any, any, PopupContainerPlatformProps>()(
  [],
  (_, carmiData) => carmiData,
);

export const stateRefs = withStateRefsValues<
  keyof IPopupContainerStateRefsValues
>(['pageId', 'setSiteScrollingBlocked']);

export default createComponentPreviewMapperModel({ props, stateRefs });
